/**
 * Class description
 *
 * Created: 2019-08-29
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {SpacierArcadeGameModuleConfig} from "../SpacierArcadeGameModuleConfig";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpacierArcadeSoundConfig} from "../SpacierArcadeSoundConfig";

export class NormalWin implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;
    private _countTo:number;
    private _hasWin:boolean;
    private _countFrom:number;
    private _duration:number;
    private _sound:string;
    private _tl:TimelineLite;

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public prepare(data:SpacierArcadeParsedGameData):void {
        this._hasWin =  data.singleWin > 0 && !data.isBigWin;
    }

    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null {
        if(!this._hasWin) {
            return null;
        }

        this._tl = new TimelineLite();
        // #353
        let restrictWinSound: boolean = SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.totalSpinWinnigs <= data.playedBetValue);

        this._tl.add([SpacierArcadeGameModuleConfig.saInitialWinPresentation.getAnimation(data),
            () => {
                // if(data.payoutMultiplier === 1 || data.currentTotalWinRatio >= 3) {
                //     this.playWinSound(data.currentTotalWinRatio);
                // }else{
                //     SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.COUNTUP_MULTI_1);
                // }
                if (!restrictWinSound){
                    this.playWinSound(data.currentWinRatioConfig!.ratio);
                }
            }
        ], 0);
        this._tl.add(this.addWinCountUpToTimeline(data, restrictWinSound), data.currentWinRatioConfig!.type === WinRatioType.LARGE?  this._tl.totalDuration() - 1 : 0.15);
        this._tl.add( () => SpacierArcadeGameModuleConfig.saWinCountUp.getEndingAnimation(data.payoutMultiplier, data.totalWinWaysWon, data.totalSpinWinnigs, data.currentWinRatioConfig), "-=0.25");
        return this._tl;
    }

    protected addWinCountUpToTimeline(data:SpacierArcadeParsedGameData, winBelowStake: boolean): TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        const duration: number = data.currentWinRatioConfig!.duration;
        let countUpTimeline: TimelineLite = new TimelineLite();
        if(data.currentWinRatioConfig!.ratio < 3) {
            tl.add(SpacierArcadeGameModuleConfig.saWinCountUp.getSmallCountUpAnimation(data.totalWinWaysWon, 0, data.singleWin, 0, data.payoutMultiplier, data.currentWinRatioConfig));
        }
        else{
            tl.add(SpacierArcadeGameModuleConfig.saWinCountUp.getCountUpAnimation(data.totalWinWaysWon, 0, data.singleWin, duration, data.currentMultiplier, data.currentWinRatioConfig));
        }
        if(data.payoutMultiplier > 1) {
            tl.add(SpacierArcadeGameModuleConfig.saWinCountUp.getMultiplierCountUpAnimation(data.singleWin, data.totalSpinWinnigs, 0.01, data.payoutMultiplier, data.currentWinRatioConfig, winBelowStake), data.currentWinRatioConfig!.ratio < 3 ? "-=0.2" : tl.totalDuration() + 0.3);
            tl.add( () => SpacierArcadeGameModuleConfig.saWinCountUp.stay(0.9));
        }

        return tl;
    }

    public abort(isActive:boolean, data:SpacierArcadeParsedGameData):Timeline | null {
        // if(isActive && this._tl) {
        //     return this._tl;
        // }
        const tl:TimelineLite = new TimelineLite();
        tl.add(SpacierArcadeGameModuleConfig.saWinCountUp.getEndingAnimation(data.payoutMultiplier, data.totalWinWaysWon, data.totalSpinWinnigs, data.currentWinRatioConfig), 0);
        return tl;
    }

    private playWinSound(winRatio:number):void {
        //console.log("WIN RATIO: " + this._winRatio);
        if(winRatio < 1.5) {
            SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.WIN_TINY);
        }
        else if(winRatio < 3) {
            SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.WIN_SMALL);
        }
        else if(winRatio < 5) {
            SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.WIN_MEDIUM);
        }
        else if(winRatio < 15) {
            SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.WIN_LARGE);
        }
    }

}